import Fields from './Fields';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';


import { getBusinessReports } from '../../selector';
import * as actions from '../../actions';

const mapStateToProps = state => {
  const {
    reports,
    fields,
    selectedFields,
    reportName,
    reportDescription,
    fetchingReportFields,
    exportingCustomisedReport,
    savingReport,
    filters,
    schedule,
    recipients,
    businessReportId,
    deletingReport,
    isScheduleUpdated
  } = state.reports;
  return {
    reports,
    fields,
    selectedFields,
    reportCategory: 'business',
    reportName,
    reportDescription,
    fetchingReportFields,
    exportingCustomisedReport,
    savingReport,
    filters,
    schedule,
    recipients,
    businessReportId,
    deletingReport,
    isScheduleUpdated
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Fields);



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/Fields/FieldsContainer.js